import reports from "../../../services/sales/reports"

export default {
    namespaced: true,
    state: {
        from: null,
        to: null,
        data: [],
        loading: false
    },
    getters: {
        from: state => state.from,
        to: state => state.to,
        data: state => state.data,
        loading: state => state.loading
    },
    mutations: {
        from: (state, payload) => state.from = payload,
        to: (state, payload) => state.to = payload,
        data: (state, payload) => state.data = payload,
        loading: (state, payload) => state.loading = payload
    },
    actions: {
        get(context) {
            return new Promise((resolve, reject) => {
                context.commit("loading", true);
                reports.paymentDetails({from: context.state.from, to: context.state.to}).then(response => {
                    context.commit("data", response.data);
                    resolve(response);
                }).catch(error => reject(error)).finally(() => {
                    context.commit("loading", false);
                })
            })
        },
        updateParams(context, payload) {
            return new Promise((resolve, reject) => {
                context.commit("from", payload.from);
                context.commit("to", payload.to);
                context.dispatch("get").then(response => resolve(response)).catch(error => reject(error));
            });
        }
    }
}